import React from "react";
import IconButton from "../IconButton";
import { Delete, Edit } from "@material-ui/icons";

export default function MainOperations({
  deleteTooltip,
  editTooltip,
  hasEditButton,
  hasDeleteButton,
  onDeleteClick,
  onEditClick,
}) {
  return (
    <React.Fragment>
      {hasEditButton && (
        <IconButton
          size="small"
          component="span"
          edge={false}
          icon={<Edit className="operational-panel" fontSize="small" />}
          tooltip={editTooltip}
          onClick={onEditClick}
        />
      )}
      {hasDeleteButton && (
        <IconButton
          size="small"
          component="span"
          edge={false}
          icon={<Delete className="operational-panel" fontSize="small" />}
          tooltip={deleteTooltip}
          onClick={onDeleteClick}
        />
      )}
    </React.Fragment>
  );
}
